import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UserService } from '../../../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SchoolService } from '../../../../../services/school.service';
import { ClassService } from '../../../../../services/class.service';
import { UserStatus, UserType } from '../../../../../model/Const';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, FormArray, UntypedFormControl } from '@angular/forms';
import { CoursewareService } from '../../../../../services/courseware.service';
import { BookItemBarComponent } from './bar';
import { TwNoticeService } from '../../../../../services/tw-notice.service';
import { HWResourceService } from '../../../../../services/huawei-resource.service';
import * as _ from 'lodash';
import { SyllabusService } from '../../../../../services/syllabus.service';
import { MediaV2Service } from '../../../../../services/media-v2.service';
import { TagsService } from '../../../../../services/tags.service';
import { parseInt } from 'lodash';
import { ExerciseService } from '../../../../../services/exercise.service';
import {
  parseDrivePathParam,
  pathIdsToDrivePathParam,
  readDrivePathIdsFromListState,
} from '../resource-drive-path.util';


@Component({
    selector: 'app-admin-resource-book-form',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    standalone: false
})
export class AdminResourceBookFormComponent implements OnInit {
  user: any = null;
  constUserType = UserType;
  currentSyllabusId = 0;
  currentCourseId = 0;
  audioErrorMessage = '';

  isLoading = false;
  form!: UntypedFormGroup;

  syllabusList: { syllabus_id: number, course_id: number}[] = [];


  item_id = 0;
  bookAttrs: any = {};
  syllabusChildren = [];
  syllabusKeyValueItems: any = {};

  globalThemesKeyValueItems: any = {};
  rootThemesKeyValueItems: any = {};
  subThemesKeyValueItems: any = {};

  relTags: any[] = [];
  bookInfo: any = null;
  flatSyllabusList: any[] = [];

  // 多级syllabus选择器相关属性
  multiLevelSyllabusFilters: any[] = [];

  bisType = 'cartoon';
  tabIndex = 0;
  items_status: any = {};
  // readingStatus = false;
  // classroomReadingStatus = false;

  host = '';
  protocol = '';
  bucket = '';
  exercise_items = [];

  itemService!: CoursewareService|MediaV2Service|ExerciseService;

  constructor(private userService: UserService,
              private clsService: ClassService,
              private syllabusService: SyllabusService,
              private tagsService: TagsService,
              private coursewareService: CoursewareService,
              private mediaService: MediaV2Service,
              private exerciseService: ExerciseService,
              private activatedRoute: ActivatedRoute ,
              private twNoticeService: TwNoticeService ,
              private router: Router ,
              private fb: UntypedFormBuilder,
              private nzMessageService: NzMessageService,
              private cdr: ChangeDetectorRef) {
    this.user = this.userService.getUserInfo();
    const u = new URL(window.location.href);
    this.protocol = u.protocol;
    this.host = HWResourceService.cdnHost;
    this.activatedRoute.title.subscribe({
      next: (title) => {
      }
    });
    console.log('[form] this.activatedRoute', this.activatedRoute.pathFromRoot[2].data);
    this.bisType = this.activatedRoute.pathFromRoot[2].snapshot.url[2].path;
    if (this.bisType === 'video' || this.bisType === 'audio') {
      this.itemService = this.mediaService;
    } else if (this.bisType === 'exercise') {
      this.itemService = this.exerciseService;
    } else {
      this.itemService = this.coursewareService;
    }
    this.activatedRoute.queryParams.subscribe( (query: any) => {
      if (query.tabIndex && parseInt(query.tabIndex, 10) === query.tabIndex * 1) {
        this.tabIndex = parseInt(query.tabIndex, 10);
      }
    });
    // this.activatedRoute.queryParams.subscribe( (query: any) => {
    //   if (query.page && parseInt(query.page, 10) === query.page * 1) {
    //     this.currentPageIndex = parseInt(query.page, 10);
    //   }
    // });
    let reserve3 = this.bisType === 'audio' ? -1 : 1;

    this.activatedRoute.params.subscribe( params => {
      console.log('params', params);
      this.item_id = +params['item_id'] || 0;
      this.form = this.fb.group({
        id: [ this.item_id ],
        school_id: [ this.user.school_id || 0 ],
        // course_id: [ '', [ Validators.required ] ],
        // theme: [ [] , [Validators.required] ],
        // level: [ '', [Validators.required]  ],
        // themes: this.fb.array([]),
        reserve3: [ reserve3 ],
        name: [ '' , [ Validators.required ]],
        // cover: [ '', [ Validators.required ] ],
        cover: [ ''],
        duration: [ '00:00'],
        size: [ '0'],
        url: [ '', (['audio', 'video'].includes(this.bisType) ? [Validators.required] : null) ],
        suffix: [''],
        tagsGroupArray: this.fb.array([])
      });

    });
    // @ts-ignore
    window.form = this.form;
  }

  clearVideo($event: any) {}
  onVideoUploadFailure($event: any) {}
  onVideoOverSize($event: any) {
    this.nzMessageService.error('too large');
  }
  onVideoCoverUploadSuccess(evt: any) {
    this.form.controls['cover'].setValue(evt.url);
  }
  onVideoUploadSuccess(evt: any) {
    if (this.bisType === 'video') {
      this.form.controls['url'].setValue(evt.url);
      const time = parseInt(String(evt.file.duration / 1000), 10);
      this.form.controls['duration'].setValue(time);
      this.form.controls['size'].setValue(evt.file.size);

      const suffix = this.getFileSuffix(evt.url);
      if (suffix) {
        this.form.controls['suffix'].setValue(suffix);
      }
      console.log('suffix', this.form.controls);
    }
  }

  getFileSuffix(url: string) {
    const lastDotIndex = (url || '').lastIndexOf('.');
    const suffix = lastDotIndex !== -1 ? url.substring(lastDotIndex + 1) : '';
    return suffix;
  }

  clearAudio($event: any) {
    console.log('clearAudio', $event);
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    this.form.controls['url'].setValue(null);
  }
  onAudioUploadFailure(evt: any) {
    console.log('onAudioUploadFailure', evt);
    let message = evt.message;
    if (evt.error) {
      message = evt.error.message;
    }
    this.audioErrorMessage = message || '音频错误';
  }
  onAudioUploadSuccess(evt: any) {
    console.log('v3/resource/from onAudioUploadSuccess', evt);
    if (this.bisType === 'audio') {
      this.form.controls['url'].setValue(evt.url);
      this.form.controls['reserve3'].setValue(-1);
      // this.form.controls['duration'].setValue(this.formatTime(evt.file.duration / 1000));
      const time = parseInt(String(evt.file.duration / 1000), 10);
      this.form.controls['duration'].setValue(time);
      this.form.controls['size'].setValue(evt.file.size);
      const suffix = this.getFileSuffix(evt.url);
      if (suffix) {
        this.form.controls['suffix'].setValue(suffix);
      }
    }
  }

  formatTime(time: number) {
    time = parseInt(String(time), 10);
    const sec = time % 60;
    const min = Math.floor(time / 60);
    const hour = Math.floor(time / (60 * 60));
    let t = `${min}:${sec}`;
    if (hour) {
      t = `${hour}:${t}`;
    }
    return t;
  }




  // get themes() {
  //   return this.form.get('themes') as FormArray;
  // }
  get tagsGroupArray () {
    return (this.form.get('tagsGroupArray') || []) as FormArray;
  }

  addTagsGroup({syllabus_id = 0, course_id = 0}: {syllabus_id?: number, course_id?: number, tags?: any[]}) {
    console.log('[添加] 添加标签组:', syllabus_id, course_id);

    // 确保multiLevelSyllabusFilters已经初始化
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      this.initializeMultiLevelSyllabusFilters();
    }

    const tagFb = this.fb.group({
      syllabus_id: this.fb.control(+syllabus_id, Validators.required),
      course_id: this.fb.control(+course_id, Validators.required),
    });

    // 计算最大深度并添加表单控件
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    // 为多级选择器添加表单控件（基于最大深度）
    for (let i = startLevel; i < endLevel; i++) {
      tagFb.addControl(`level_${i}`, this.fb.control(null));
    }

    this.tagsGroupArray.push(tagFb);

    // 添加表单值变化监听器
    const groupIndex = this.tagsGroupArray.length - 1;
    this.setupFormValueListeners(groupIndex, tagFb);

    console.log('[添加] 标签组添加完成，当前总数:', this.tagsGroupArray.length);
  }


  /**
   * 设置表单值变化监听器
   * @param groupIndex 分组索引
   * @param formGroup 表单组
   */
  setupFormValueListeners(groupIndex: number, formGroup: FormGroup) {
    // 监听一级分类变化
    formGroup.get('syllabus_id')?.valueChanges.subscribe(value => {
      console.log('[监听] 一级分类值变化:', groupIndex, value);
      this.changeSyllabusInternal(groupIndex, value);
    });

    // 监听二级大纲变化
    formGroup.get('course_id')?.valueChanges.subscribe(value => {
      console.log('[监听] 二级大纲值变化:', groupIndex, value);
      this.changeCourseInternal(groupIndex, value);
    });

    // 监听多级选择器变化
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2;
    const endLevel = maxDepth;
    console.log(startLevel, endLevel);
    for (let i = startLevel; i < endLevel; i++) {
      formGroup.get(`level_${i}`)?.valueChanges.subscribe(value => {
        console.log(`[监听] 层级${i}值变化:`, groupIndex, value);
        this.changeMultiLevelSyllabusInternal(groupIndex, i, value);
      });
    }
  }

  removeTagsGroup(index: number): void {
    console.log('[删除] 删除标签组:', index);
    this.tagsGroupArray.removeAt(index);
  }
  clearTagsField({prefix = '', parent = null}: {prefix?: string, parent?: FormGroup|null}) {
    if (!parent) {
      parent = this.form;
    }
    const keys = Object.keys(parent.controls);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].startsWith(`${prefix}.`)) {
        parent.removeControl(keys[i]);
      }
    }
  }
  addTagsField({id, value = null, prefix = '', parent = null}: {id: any, value?: any, prefix?: string,  parent?: FormGroup|null}): void {
    if (!parent) {
      parent = this.form;
    }
    const tagsControl = [];
    parent.addControl(
      `${prefix}.` + id,
      // new UntypedFormControl(null, Validators.required)
      new UntypedFormControl(value)
    );
  }

  flatListToTreeV2 ({list ,
                      idPaths = ['id'],
                      parentIdPath = 'pid',
                      childListPath = 'children',
                      // tslint:disable-next-line:max-line-length
                      isParent = (node: any) => !node.pid}: {list: any[], idPaths?: string|string[], parentIdPath?: string, childListPath?: string,
    isParent?: (node: any) => Boolean}) {
    if (typeof idPaths === 'string') {
      idPaths = [];
    }
    const rootParents = [];
    // @ts-ignore
    const findValidPathId = (item: any) => {
      for (let i = 0; i < idPaths.length; i++) {
        if (item[idPaths[i]]) {
          return idPaths[i];
        }
      }

    };
    const map: any = {};
    for (const item of list) {
      if (!item[childListPath]) { item[childListPath] = []; }
      const idPath = findValidPathId(item);
      if (!idPath) {
        throw new Error('not found valid id path in tree');
      }
      map[item[idPath]] = item;
    }
    for (const item of list) {
      const parentId = item[parentIdPath];
      if (isParent(item)) {
        rootParents.push(item);
      } else {
        const parentItem = map[parentId];
        if (parentItem) {
          parentItem[childListPath].push(item);
        }
      }
    }
    return rootParents;
  }
  get titleName() {
    let title = '';
    if (this.bisType === 'cartoon') {
      title = '绘本';
    } else if (this.bisType === 'book') {
      title = '绘本';
    } else if (this.bisType === 'audio') {
      title = '音频';
    } else if (this.bisType === 'video') {
      title = '视频';
    } else if (this.bisType === 'exercise') {
      title = '练习';
    }
    return title;
  }
  get actionName() {
    let action = '新增';
    if (this.item_id) {
      action = '编辑';
    }
    return action;
  }
  get backUrl () {
    return `/admin/v3/resource/${this.bisType}/list`;
  }
  ngOnInit() {
    this.isLoading = true;
    // this.coursewareService.bookAttrs(this.bisType).then((bookAttrs) => {
    this.syllabusService.category(this.bisType).then((bookAttrs) => {
      console.log('bookAttrs', bookAttrs);
      const _themesKeyValueItems  = _.groupBy(bookAttrs.themes || [], 'syllabus_id');
      this.flatSyllabusList = this.flattenTree(bookAttrs.syllabus || []);
      if (this.flatSyllabusList && this.flatSyllabusList.length > 0) {
        this.flatSyllabusList.forEach((syllabus: any) => {
          if (typeof syllabus.path === 'string') {
            const pathParts = syllabus.path.split('/');
            syllabus.path_parts = [ ...pathParts.filter((p: string) => p.trim()).map((path: any) => +path), syllabus.id];
          }
        });
      }

      // this.rootThemesKeyValueItems = _.keyBy(bookAttrs.syllabus, 'id');
      // this.rootThemesKeyValueItems = _.groupBy(bookAttrs.syllabus, 'id');
      this.rootThemesKeyValueItems = _.groupBy(bookAttrs.themes || [], 'syllabus_id');
      this.globalThemesKeyValueItems = bookAttrs.global_tags || [];
      // if (bookAttrs?.global_tags && bookAttrs?.global_tags[0]) {
      //   const id = bookAttrs.global_tags[0].id;
      //   this.rootThemesKeyValueItems[0] = bookAttrs?.global_tags;
      // }


      // @ts-ignore
      // this.rootThemesKeyValueItems2 = _.groupBy(bookAttrs.syllabus, 'id');
      this.subThemesKeyValueItems = _themesKeyValueItems || {};

      this.syllabusKeyValueItems = _.keyBy(this.flatSyllabusList || [], 'id');

      const tagsGroupItems = _.groupBy(bookAttrs.themes || [], 'syllabus_id');
      console.log('tag group ', tagsGroupItems);

      this.bookAttrs = bookAttrs || {};

      // 初始化多级syllabus选择器
      this.initializeMultiLevelSyllabusFilters();

      if (!this.item_id) {
        this.applyInitialDrivePath();
        this.isLoading = false;
        return;
      }

      if (this.item_id) {
        this.itemService.fetch(this.bisType, this.item_id).then((result) => {
          console.log('itemService.fetch', result);
          this.exercise_items = result.exercise_items || [];
          this.bookInfo = result;
          this.form.controls['name'].setValue(result.name);
          this.form.controls['size'].setValue(result.size);
          this.form.controls['duration'].setValue(result.duration);
          // tslint:disable-next-line:max-line-length
          const cover = (result.cover && (result.cover.startsWith('http') ? result.cover : this.protocol + '//' + this.host + '/' + (this.bucket ? this.bucket + '/' : '') + result.cover));
          this.form.controls['cover'].setValue(cover);
          this.form.controls['reserve3'].setValue(result.reserve3);

          if (result.url && this.form.controls['url'] ) {
            // tslint:disable-next-line:max-line-length
            const url = (result.url && (result.url.startsWith('http') ? result.url : this.protocol + '//' + this.host + '/' + (this.bucket ? this.bucket + '/' : '') + result.url));
            this.form.controls['url'].setValue(url);
          }


          this.items_status = result.items_status;
          // this.relTags = result.themes;
          this.relTags = result.themes || [];

          let fieldIndex = 0;
          // result.syllabus
          this.relTags.forEach((tag: any, i: number) => {
            const tg = this.syllabusKeyValueItems[tag.syllabus_id];
            if (+tag.syllabus_id && !tg) {
              return;
            }
            // const tg = this.findParentTag(bookAttrs.themes, tagGroup.syllabus_id);
            const syllabus_id = tg?.path_parts?.length > 0 ? tg?.path_parts[0] : 0;
            if (syllabus_id == 0) {
              return;
            }
            const course_id = tg?.path_parts?.length > 1 ? tg?.path_parts[1] : 0;
            this.addTagsGroup({syllabus_id, course_id} );
            this.changeSyllabus(fieldIndex, syllabus_id);
            this.changeCourse(fieldIndex, course_id);

            // 解析path并设置多级选择器的值
            if (tag.path && typeof tag.path === 'string') {
              const pathData = this.parsePath(tag.path);
              const group = this.tagsGroupArray.controls[fieldIndex] as FormGroup;

              // 确保multiLevelSyllabusFilters已经初始化
              if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
                this.initializeMultiLevelSyllabusFilters();
              }

              // 计算最大深度
              const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
              const startLevel = 2; // 从第三级开始
              const endLevel = maxDepth; // 直接使用最大深度，不需要减1

              // 设置第三级及以后的值
              for (let level = startLevel; level < endLevel; level++) {
                const levelValue = pathData[`level_${level}`];
                if (levelValue) {
                  const levelControl = group.controls[`level_${level}`];
                  if (levelControl) {
                    levelControl.setValue(levelValue);
                    // 更新层级名称
                    this.updateMultiLevelName(fieldIndex, level, levelValue);
                  }
                }
              }
            }

            fieldIndex++;

            // syllabusChildren
            // const groupArray = this.form.controls['tagsGroupArray'] as FormArray;
            // const group = groupArray.at(groupArray.length - 1) as FormGroup;
            // tagGroup.tags.forEach((v: any) => {
            //   this.addTagsField({id: v.tag_group_id , value: v.tag_id, prefix: 'tag_group_id', parent: group});
            // });
          });




          this.isLoading = false;
        }).catch(err => {
            throw err;
        });
      }

    }).catch(err => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System Error');
    });
  }


  flattenTree(tree: any): any {
    if (!tree || !Array.isArray(tree)) {
      return [];
    }

    return _.flatMap(tree, (node) => {
      const { children, ...rest } = node;
      return [rest, ...this.flattenTree(children || [])];
    });
  }

  findParentTag(targetList: any, id: any) {
    if (!targetList || !Array.isArray(targetList)) {
      return null;
    }

    for (let i = 0; i < targetList.length; i++) {
      const target = targetList[i];
      const find = target.children?.find((child: any) => +child.id === +id);
      if (find) {
        return target;
      }
    }

    return null;
  }

  currentSubOptions (group_index: number) {
    if (group_index >= this.tagsGroupArray.controls.length) {
      return [];
    }

    const group = this.tagsGroupArray.controls[group_index] as FormGroup;
    const syllabus_id = group.controls['syllabus_id']?.value;

    if (!syllabus_id || !this.bookAttrs.syllabus) {
      return [];
    }

    // const a = this.rootThemesKeyValueItems[syllabus_id.value];
    // return a?.children;
    const item = this.bookAttrs.syllabus.find((s: any) => {
      return +s.id === +syllabus_id;
    });
    return item?.children || [];
  }

  currentRootTags() {

  }



  // 添加标志位来避免递归
  private isProcessingChange = false;

  /**
   * 内部方法：处理一级分类变化（避免递归）
   */
  changeSyllabusInternal(group_index: number, syllabus_id: number) {
    if (this.isProcessingChange) {
      console.log('[内部] 跳过递归调用');
      return;
    }

    this.isProcessingChange = true;
    console.log('[内部] 一级分类变化:', group_index, syllabus_id);
    this.debugFormState(group_index, '重置前');

    if (!(+syllabus_id)) {
      this.isProcessingChange = false;
      return;
    }

    if (group_index >= this.tagsGroupArray.controls.length) {
      this.isProcessingChange = false;
      return;
    }

    const group = (this.tagsGroupArray.controls[group_index] as FormGroup);

    // 重置第二级（大纲）选择
    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.reset(-1);
      console.log('[重置] 二级大纲已重置为-1');
    }

    // 重置第三级及以后的所有选择
    this.resetLevelsFrom(group_index, 2);

    // 强制触发变更检测，确保UI立即更新
    this.tagsGroupArray.updateValueAndValidity();
    this.cdr.detectChanges();

    if (typeof syllabus_id === 'undefined') {
      this.currentSyllabusId = 0;
      this.currentCourseId = 0;
      this.syllabusChildren = [];
      this.isProcessingChange = false;
      return;
    }

    this.currentSyllabusId = syllabus_id;
    const selectedTags = this.rootThemesKeyValueItems[syllabus_id] || [];
    const tagGroupItem = this.relTags.find(tag => +tag.syllabus_id === +syllabus_id);
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +syllabus_id) || [];
    const a = this.bookInfo;
    tags.forEach((tag: any) => {
      // const value = tag.children?.map((v: any) => v.id) || [];
      const tagItem = tagGroupItem?.tags?.find((s: any) => {
        return s.tag_group_id === +tag.id;
      });
      this.addTagsField({
        id: tag.id,
        value: tagItem?.tag_id ,
        // value: tagGroupItem?.tag_id ,
        prefix: 'tag_group_id',
        parent: group});
    });

    // 再次强制触发变更检测，确保UI正确更新
    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      this.cdr.detectChanges();
      this.debugFormState(group_index, '重置后');
      console.log('[重置] UI更新完成');
      this.isProcessingChange = false;
    }, 0);
  }

  changeSyllabus(group_index: number, syllabus_id: number) {
    console.log('[重置] 一级分类变化:', group_index, syllabus_id);
    console.log('[测试] changeSyllabus方法被调用');
    this.debugFormState(group_index, '重置前');

    if (!(+syllabus_id)) {
      return;
    }

    if (group_index >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = (this.tagsGroupArray.controls[group_index] as FormGroup);

    // 重置第二级（大纲）选择
    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.reset(-1);
      console.log('[重置] 二级大纲已重置为-1');
    }

    // 重置第三级及以后的所有选择
    this.resetLevelsFrom(group_index, 2);

    // 强制触发变更检测，确保UI立即更新
    this.tagsGroupArray.updateValueAndValidity();
    this.cdr.detectChanges();

    if (typeof syllabus_id === 'undefined') {
      this.currentSyllabusId = 0;
      this.currentCourseId = 0;
      this.syllabusChildren = [];
      return;
    }

    this.currentSyllabusId = syllabus_id;
    const selectedTags = this.rootThemesKeyValueItems[syllabus_id] || [];
    const tagGroupItem = this.relTags.find(tag => +tag.syllabus_id === +syllabus_id);
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +syllabus_id) || [];
    const a = this.bookInfo;
    tags.forEach((tag: any) => {
      // const value = tag.children?.map((v: any) => v.id) || [];
      const tagItem = tagGroupItem?.tags?.find((s: any) => {
        return s.tag_group_id === +tag.id;
      });
      this.addTagsField({
        id: tag.id,
        value: tagItem?.tag_id ,
        // value: tagGroupItem?.tag_id ,
        prefix: 'tag_group_id',
        parent: group});
    });

    // 再次强制触发变更检测，确保UI正确更新
    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      this.cdr.detectChanges();
      this.debugFormState(group_index, '重置后');
      console.log('[重置] UI更新完成');
    }, 0);
  }



  /**
   * 内部方法：处理二级大纲变化（避免递归）
   */
  changeCourseInternal(group_index: number, course_id: number) {
    if (this.isProcessingChange) {
      console.log('[内部] 跳过递归调用');
      return;
    }

    this.isProcessingChange = true;
    console.log('[内部] 二级大纲变化:', group_index, course_id);
    this.debugFormState(group_index, '重置前');

    if (group_index >= this.tagsGroupArray.controls.length) {
      this.isProcessingChange = false;
      return;
    }

    const group = (this.tagsGroupArray.controls[group_index] as FormGroup);
    if (!group) {
      this.isProcessingChange = false;
      return;
    }

    if (!(+course_id) || !course_id) {
      // 如果course_id无效，重置第三级及以后的所有选择
      this.resetLevelsFrom(group_index, 2);
      this.currentCourseId = 0;
      console.log('[重置] 二级大纲无效，已重置后续选择');
      this.isProcessingChange = false;
      return;
    }

    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.setValue(+course_id, {emitViewToModelChange: false});
    }

    // 重置第三级及以后的所有选择
    this.resetLevelsFrom(group_index, 2);

    // 强制触发变更检测，确保UI立即更新
    this.tagsGroupArray.updateValueAndValidity();
    this.cdr.detectChanges();

    this.currentCourseId = course_id;
    const selectedTags = this.subThemesKeyValueItems[course_id] || [];
    const tagGroupItem = this.relTags.find(t => +t.syllabus_id === +course_id);
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +course_id) || [];
    tags.forEach((tag: any) => {
      const value = tag.children?.map((v: any) => v.id) || [];
      const tagItem = tagGroupItem?.tags?.find((s: any) => {
        return s.tag_group_id === +tag.id;
      });
      this.addTagsField({
        value: tagItem?.tag_id,
        id: tag.id,
        prefix: 'tag_id',
        parent: group});
    });

    // 再次强制触发变更检测，确保UI正确更新
    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      this.cdr.detectChanges();
      this.debugFormState(group_index, '重置后');
      console.log('[重置] UI更新完成');
      this.isProcessingChange = false;
    }, 0);
  }

  changeCourse(group_index: number, course_id: number) {
    console.log('[重置] 二级大纲变化:', group_index, course_id);
    this.debugFormState(group_index, '重置前');

    if (group_index >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = (this.tagsGroupArray.controls[group_index] as FormGroup);
    if (!group) {
      return;
    }

    if (!(+course_id) || !course_id) {
      // 如果course_id无效，重置第三级及以后的所有选择
      this.resetLevelsFrom(group_index, 2);
      this.currentCourseId = 0;
      console.log('[重置] 二级大纲无效，已重置后续选择');
      return;
    }

    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.setValue(+course_id, {emitViewToModelChange: false});
    }

    // 重置第三级及以后的所有选择
    this.resetLevelsFrom(group_index, 2);

    // 强制触发变更检测，确保UI立即更新
    this.tagsGroupArray.updateValueAndValidity();
    this.cdr.detectChanges();

    this.currentCourseId = course_id;
    const selectedTags = this.subThemesKeyValueItems[course_id] || [];
    const tagGroupItem = this.relTags.find(t => +t.syllabus_id === +course_id);
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +course_id) || [];
    tags.forEach((tag: any) => {
      const value = tag.children?.map((v: any) => v.id) || [];
      const tagItem = tagGroupItem?.tags?.find((s: any) => {
        return s.tag_group_id === +tag.id;
      });
      this.addTagsField({
        value: tagItem?.tag_id,
        id: tag.id,
        prefix: 'tag_id',
        parent: group});
    });

    // 再次强制触发变更检测，确保UI正确更新
    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      this.cdr.detectChanges();
      this.debugFormState(group_index, '重置后');
      console.log('[重置] UI更新完成');
    }, 0);
  }

  tabIndexChange($evt: any) {
    console.log('tabIndexChange', $evt, this.tabIndex);
    this.tabIndex = $evt;
  }
  noticeReadingStatus() {
    this.twNoticeService.warning({nzContent: '請先上傳Reading素材'});
  }
  setCover(event: any) {
    this.form.controls['cover'].setValue(event.url);
  }

  submitForm = ($event: any, value: any) => {
    if ($event) {
      $event.preventDefault();
    }
    if (this.isLoading) {
      return;
    }
    for (const key in this.form.controls) {
      this.form.controls[ key ].markAsDirty();
      this.form.controls[ key ].updateValueAndValidity();
    }

    console.log('submitForm', $event, value);
    let tagValid = true;
    value.tagsGroupArray.forEach((tag: any, groupIndex: number) => {
      const {course_id, syllabus_id} = tag;
      if (course_id <= 0 || syllabus_id < 0) {
        tagValid = false;
      }

      // 验证多级选择器的必填字段
      const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
      if (group) {
        // 获取当前选择路径的实际深度
        const actualDepth = this.getActualSelectionDepth(groupIndex);
        const startLevel = 2; // 从第三级开始

        // 只验证到实际深度
        for (let i = startLevel; i < actualDepth; i++) {
          const levelControl = group.controls[`level_${i}`];
          if (levelControl && this.shouldShowLevelSelector(groupIndex, i)) {
            // 如果该层级应该显示，则检查是否已选择
            const levelValue = levelControl.value;
            if (!levelValue || levelValue <= 0) {
              tagValid = false;
              console.log(`多级选择器验证失败: level_${i} 未选择`);
            }
          }
        }
      }
    });

    if (!this.form.controls['cover'].value) {
      this.nzMessageService.error('请正确上传封面');
      return;
    }

    if (!tagValid || !value.tagsGroupArray || (Array.isArray(value.tagsGroupArray) && value.tagsGroupArray.length === 0)) {
      this.nzMessageService.error('请正确关联分类');
      return;
    }

    // 为每个分组构建path字段
    value.tagsGroupArray.forEach((tagGroup: any, index: number) => {
      tagGroup.path = this.buildPath(index);
    });

    this.isLoading = true;
    this.itemService.save(this.bisType, value).then((result) => {
      this.isLoading = false;
      const modal = this.twNoticeService.success({nzContent: '保存成功'});
      modal.afterClose.subscribe(() => {
        if (!this.item_id) {
          this.router.navigate([`/admin/v3/resource/${this.bisType}`]);
        }

      });
    }).catch(err => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System Error');
    });
  }

  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.form.reset();
    for (const key in this.form.controls) {
      this.form.controls[ key ].markAsPristine();
      this.form.controls[ key ].updateValueAndValidity();
    }
  }

  dragStart($evt: any) {
    console.log('dragStart', $evt);
  }
  dragging($evt: any) {
    console.log('dragging', $evt);
  }

  reloadData() {
    this.ngOnInit();
  }

  /**
   * 计算syllabus树的最大深度
   * @param nodes 节点数组
   * @param currentDepth 当前深度
   * @returns 最大深度
   */
  getMaxDepth(nodes: any[], currentDepth: number = 1): number {
    if (!nodes || !Array.isArray(nodes) || nodes.length === 0) {
      return currentDepth - 1;
    }

    let maxDepth = currentDepth;

    for (const node of nodes) {
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        const childDepth = this.getMaxDepth(node.children, currentDepth + 1);
        maxDepth = Math.max(maxDepth, childDepth);
      }
    }

    return maxDepth;
  }

  /**
   * 初始化多级syllabus选择器
   */
  initializeMultiLevelSyllabusFilters() {
    this.multiLevelSyllabusFilters = [];

    // 计算syllabus树的最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    console.log('[初始化] syllabus树最大深度:', maxDepth);

    // 动态添加第三级及以后的层级（基于最大深度）
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    for (let i = startLevel; i < endLevel; i++) {
      this.multiLevelSyllabusFilters.push({
        level: i,
        name: `级别${i + 1}`,
        field: `level_${i}`,
        options: [],
        placeholder: `级别${i + 1}`
      });
    }

    console.log('[初始化] 多级选择器初始化完成，数量:', this.multiLevelSyllabusFilters.length);
  }

  /**
   * 判断是否应该显示某个层级的选择器
   * @param groupIndex 分组索引
   * @param level 层级
   * @returns 是否显示
   */
  shouldShowLevelSelector(groupIndex: number, level: number): boolean {
    // 如果multiLevelSyllabusFilters还没有初始化，不显示
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      return false;
    }

    // 只有音频和视频资源才显示多级选择器
    if (this.bisType !== 'audio' && this.bisType !== 'video') {
      return false;
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return false;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return false;
    }

    const courseId = group.controls['course_id']?.value;

    // 如果第二级（大纲）没有选择或为-1，不显示第三级及以后的选择器
    if (!courseId || courseId <= 0) {
      return false;
    }

    // 检查当前层级的表单控件是否存在
    const levelControl = group.controls[`level_${level}`];
    if (!levelControl) {
      return false;
    }

    // 对于第三级，只要有第二级选择就显示
    if (level === 2) {
      const options = this.getMultiLevelSyllabusOptions(groupIndex, level);
      return options && options.length > 0;
    }

    // 对于第四级及以后，需要检查上一级是否有选择
    if (level > 2) {
      const parentLevel = level - 1;
      const parentValue = group.controls[`level_${parentLevel}`]?.value;
      if (!parentValue || parentValue <= 0) {
        return false;
      }
    }

    // 检查当前层级是否有选项
    const options = this.getMultiLevelSyllabusOptions(groupIndex, level);
    return options && options.length > 0;
  }

  /**
   * 获取多级syllabus选择器的选项
   * @param groupIndex 分组索引
   * @param level 层级
   * @returns 选项数组
   */
  getMultiLevelSyllabusOptions(groupIndex: number, level: number): any[] {
    // 如果multiLevelSyllabusFilters还没有初始化，返回空数组
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      return [];
    }

    // 只有音频和视频资源才返回多级选择器选项
    if (this.bisType !== 'audio' && this.bisType !== 'video') {
      return [];
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return [];
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return [];
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    if (level === 2) {
      // 第三级：基于第二级（大纲）的选择
      const courseId = group.controls['course_id']?.value;
      if (!courseId || courseId <= 0) {
        return [];
      }
      return this.getChildrenByParentId(courseId);
    } else if (level > 2 && level < endLevel) {
      // 第四级及以后：基于上一级的选择
      const parentLevel = level - 1;
      const parentValue = group.controls[`level_${parentLevel}`]?.value;
      if (!parentValue || parentValue <= 0) {
        return [];
      }
      return this.getChildrenByParentId(parentValue);
    }

    return [];
  }

  /**
   * 根据父节点ID获取子节点
   * @param parentId 父节点ID
   * @returns 子节点数组
   */
  getChildrenByParentId(parentId: number): any[] {
    if (!parentId || !this.bookAttrs.syllabus || !Array.isArray(this.bookAttrs.syllabus)) {
      return [];
    }

    // 从syllabus树形结构中查找子节点
    const findChildren = (nodes: any[], parentId: number): any[] => {
      for (const node of nodes) {
        if (node.id === parentId && node.children) {
          return node.children;
        }
        if (node.children) {
          const result = findChildren(node.children, parentId);
          if (result.length > 0) {
            return result;
          }
        }
      }
      return [];
    };

    return findChildren(this.bookAttrs.syllabus, parentId);
  }





  /**
   * 内部方法：处理多级syllabus选择变化（避免递归）
   */
  changeMultiLevelSyllabusInternal(groupIndex: number, level: number, value: number) {
    if (this.isProcessingChange) {
      console.log('[内部] 跳过递归调用');
      return;
    }

    this.isProcessingChange = true;
    console.log(`[内部] 层级${level}变化:`, groupIndex, value);

    // 如果multiLevelSyllabusFilters还没有初始化，不执行
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      this.isProcessingChange = false;
      return;
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      this.isProcessingChange = false;
      return;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      this.isProcessingChange = false;
      return;
    }

    // 设置当前层级的值
    const levelControl = group.controls[`level_${level}`];
    if (levelControl) {
      levelControl.setValue(value);
    }

    // 重置后续层级的所有选择
    this.resetLevelsFrom(groupIndex, level + 1);

    // 更新层级名称
    this.updateMultiLevelName(groupIndex, level, value);

    // 检查下一级是否有选项，如果有则确保下一级控件存在
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1
    const nextLevel = level + 1;
    if (nextLevel < endLevel) {
      const nextLevelOptions = this.getMultiLevelSyllabusOptions(groupIndex, nextLevel);
      if (nextLevelOptions && nextLevelOptions.length > 0) {
        // 确保下一级控件存在
        if (!group.controls[`level_${nextLevel}`]) {
          group.addControl(`level_${nextLevel}`, this.fb.control(null));
          console.log(`[多级] 动态添加控件 level_${nextLevel}`);
        }
      }
    }

    // 强制触发变更检测，确保下一级选择器能够正确显示
    setTimeout(() => {
      // 触发变更检测
      this.tagsGroupArray.updateValueAndValidity();
      this.cdr.detectChanges();
      console.log(`[多级] UI更新完成`);
      this.isProcessingChange = false;
    }, 0);
  }

  /**
   * 处理多级syllabus选择变化
   * @param groupIndex 分组索引
   * @param level 层级
   * @param value 选中的值
   */
  changeMultiLevelSyllabus(groupIndex: number, level: number, value: number) {
    console.log(`[多级] 层级${level}变化:`, groupIndex, value);

    // 如果multiLevelSyllabusFilters还没有初始化，不执行
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      return;
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return;
    }

    // 设置当前层级的值
    const levelControl = group.controls[`level_${level}`];
    if (levelControl) {
      levelControl.setValue(value);
    }

    // 重置后续层级的所有选择
    this.resetLevelsFrom(groupIndex, level + 1);

    // 更新层级名称
    this.updateMultiLevelName(groupIndex, level, value);

    // 检查下一级是否有选项，如果有则确保下一级控件存在
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1
    const nextLevel = level + 1;
    if (nextLevel < endLevel) {
      const nextLevelOptions = this.getMultiLevelSyllabusOptions(groupIndex, nextLevel);
      if (nextLevelOptions && nextLevelOptions.length > 0) {
        // 确保下一级控件存在
        if (!group.controls[`level_${nextLevel}`]) {
          group.addControl(`level_${nextLevel}`, this.fb.control(null));
          console.log(`[多级] 动态添加控件 level_${nextLevel}`);
        }
      }
    }

    // 强制触发变更检测，确保下一级选择器能够正确显示
    setTimeout(() => {
      // 触发变更检测
      this.tagsGroupArray.updateValueAndValidity();
      this.cdr.detectChanges();
      console.log(`[多级] UI更新完成`);
    }, 0);
  }

  /**
   * 调试方法：打印表单状态
   * @param groupIndex 分组索引
   * @param message 消息前缀
   */
  debugFormState(groupIndex: number, message: string = '') {
    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return;
    }

    const state = {
      syllabus_id: group.controls['syllabus_id']?.value,
      course_id: group.controls['course_id']?.value,
      level_2: group.controls['level_2']?.value,
      level_3: group.controls['level_3']?.value,
      level_4: group.controls['level_4']?.value,
    };

    console.log(`[调试] ${message} 表单状态:`, state);
  }

  /**
   * 重置指定层级及以后的所有选择
   * @param groupIndex 分组索引
   * @param fromLevel 从哪个层级开始重置
   */
  resetLevelsFrom(groupIndex: number, fromLevel: number) {
    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return;
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    console.log(`[重置] 重置层级 ${fromLevel} 到 ${endLevel}`);

    // 清除从指定层级开始的所有选择
    for (let i = fromLevel; i < endLevel; i++) {
      const levelControl = group.controls[`level_${i}`];
      if (levelControl) {
        levelControl.setValue(null);
        console.log(`[重置] 层级 ${i} 已重置为null`);
      }
    }

    // 清除相关的标签字段
    if (fromLevel === 2) {
      // 如果从第三级开始重置，清除第二级相关的标签字段
      this.clearTagsField({prefix: 'tag_group_id', parent: group});
      console.log('[重置] 已清除tag_group_id字段');
    }
    // 清除第三级及以后相关的标签字段
    this.clearTagsField({prefix: 'tag_id', parent: group});
    console.log('[重置] 已清除tag_id字段');
  }

  /**
   * 根据选中的父节点更新子节点的名称
   * @param groupIndex 分组索引
   * @param level 当前层级
   * @param selectedValue 选中的值
   */
  updateMultiLevelName(groupIndex: number, level: number, selectedValue: number) {
    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    if (level >= endLevel - 1 || !this.bookAttrs.syllabus) {
      return;
    }

    // 查找选中的节点
    const selectedNode = this.findNodeById(this.bookAttrs.syllabus, selectedValue);
    if (selectedNode && selectedNode.children && selectedNode.children.length > 0) {
      // 如果选中的节点有子节点，更新下一级的名称
      const nextLevel = level + 1;
      if (nextLevel < endLevel && nextLevel < this.multiLevelSyllabusFilters.length) {
        // 尝试从子节点的第一个元素获取层级名称
        const firstChild = selectedNode.children[0];
        if (firstChild && firstChild.level_name) {
          this.multiLevelSyllabusFilters[nextLevel - startLevel].name = firstChild.level_name;
          this.multiLevelSyllabusFilters[nextLevel - startLevel].placeholder = firstChild.level_name;
        } else {
          // 如果没有level_name，使用默认名称
          this.multiLevelSyllabusFilters[nextLevel - startLevel].name = `级别${nextLevel + 1}`;
          this.multiLevelSyllabusFilters[nextLevel - startLevel].placeholder = `级别${nextLevel + 1}`;
        }
      }
    }
  }

  /**
   * 根据ID查找节点
   * @param nodes 节点数组
   * @param id 要查找的ID
   * @returns 找到的节点或null
   */
  findNodeById(nodes: any[], id: number): any {
    if (!nodes || !Array.isArray(nodes)) {
      return null;
    }

    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children) {
        const result = this.findNodeById(node.children, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  private resolveInitialDrivePath(): string | null {
    const pathParam = this.activatedRoute.snapshot.queryParamMap.get('path');
    if (pathParam?.trim()) {
      return pathParam.trim();
    }
    const pathIds = readDrivePathIdsFromListState(this.bisType);
    return pathIdsToDrivePathParam(pathIds);
  }

  private applyInitialDrivePath(): void {
    if (this.item_id || this.tagsGroupArray.length > 0) {
      return;
    }
    const path = this.resolveInitialDrivePath();
    if (!path) {
      return;
    }
    const pathData = this.parsePath(path);
    if (!pathData.syllabus_id) {
      return;
    }
    const syllabus_id = pathData.syllabus_id;
    const course_id = pathData.course_id ?? 0;
    this.addTagsGroup({ syllabus_id, course_id });
    this.changeSyllabus(0, syllabus_id);
    if (course_id > 0) {
      this.changeCourse(0, course_id);
    }
    const group = this.tagsGroupArray.controls[0] as FormGroup;
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2;
    for (let level = startLevel; level < maxDepth; level++) {
      const levelValue = pathData[`level_${level}`];
      if (!levelValue) {
        continue;
      }
      const levelControl = group.controls[`level_${level}`];
      if (levelControl) {
        levelControl.setValue(levelValue);
        this.updateMultiLevelName(0, level, levelValue);
      }
    }
  }

  /**
   * 解析path字符串，获取各个层级的ID
   * @param path 路径字符串，如 "1/2/123/456"
   * @returns 解析后的对象
   */
  parsePath(path: string): any {
    const parsed = parseDrivePathParam(path);
    return {
      syllabus_id: parsed.syllabus_id,
      course_id: parsed.course_id,
      ...parsed.levels,
    };
  }

  /**
   * 获取当前选择路径的实际深度
   * @param groupIndex 分组索引
   * @returns 实际深度
   */
  getActualSelectionDepth(groupIndex: number): number {
    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return 2; // 默认只有两级
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return 2;
    }

    // 检查第一级和第二级是否已选择
    const syllabusId = group.controls['syllabus_id']?.value;
    const courseId = group.controls['course_id']?.value;

    if (!syllabusId || syllabusId <= 0) {
      return 0; // 第一级未选择
    }

    if (!courseId || courseId <= 0) {
      return 1; // 只有第一级
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    // 从第三级开始检查，找到最后一个有选项的层级
    let actualDepth = 2; // 默认深度为2（第一级和第二级）

    for (let i = startLevel; i < endLevel; i++) {
      // 检查该层级是否有选项可显示
      const options = this.getMultiLevelSyllabusOptions(groupIndex, i);
      if (options && options.length > 0) {
        actualDepth = i + 1; // 更新实际深度
      } else {
        // 如果没有选项，说明已经到达叶子节点
        break;
      }
    }

    console.log(`getActualSelectionDepth: groupIndex=${groupIndex}, actualDepth=${actualDepth}`);
    return actualDepth;
  }

  /**
   * 构建path字符串
   * @param groupIndex 分组索引
   * @returns path字符串
   */
  buildPath(groupIndex: number): string {
    // 如果multiLevelSyllabusFilters还没有初始化，返回空字符串
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      return '';
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return '';
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return '';
    }

    const pathParts: string[] = [];

    // 添加第一级（分类）
    const syllabusId = group.controls['syllabus_id']?.value;
    if (syllabusId && syllabusId > 0) {
      pathParts.push(syllabusId.toString());
    }

    // 添加第二级（大纲）
    const courseId = group.controls['course_id']?.value;
    if (courseId && courseId > 0) {
      pathParts.push(courseId.toString());
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    // 添加第三级及以后的ID
    for (let i = startLevel; i < endLevel; i++) {
      const levelValue = group.controls[`level_${i}`]?.value;
      if (levelValue && levelValue > 0) {
        pathParts.push(levelValue.toString());
      } else {
        break; // 如果某个层级没有值，停止添加
      }
    }

    return pathParts.join('/');
  }

  protected readonly UserStatus = UserStatus;
  protected readonly Boolean = Boolean;
  protected readonly JSON = JSON;
  protected readonly Object = Object;
  protected readonly Array = Array;
  protected readonly parseInt = parseInt;
}
